import { TFunction } from '@transifex/react'
import { createUseTranslationMap } from '@vend/react-utilities'
import { CASH_MOVEMENT_TYPES } from '../../../constants'

let typesMap: Record<string, string> = {}

const buildTypesMap = (t: TFunction) => {
  typesMap = {
    [CASH_MOVEMENT_TYPES.CASH_IN]: t('Cash in', {
      _context: 'Cash Movement Type',
    }),
    [CASH_MOVEMENT_TYPES.CASH_OUT]: t('Cash out', {
      _context: 'Cash Movement Type',
    }),
    [CASH_MOVEMENT_TYPES.PETTY_CASH_IN]: t('Petty cash in', {
      _context: 'Cash Movement Type',
    }),
    [CASH_MOVEMENT_TYPES.PETTY_CASH_OUT]: t('Petty cash out', {
      _context: 'Cash Movement Type',
    }),
    [CASH_MOVEMENT_TYPES.CLOSING_CASH_FLOAT]: t('Closing float', {
      _context: 'Cash Movement Type',
    }),
    [CASH_MOVEMENT_TYPES.OPENING_CASH_FLOAT]: t('Opening float', {
      _context: 'Cash Movement Type',
    }),
    [CASH_MOVEMENT_TYPES.FLOAT_ADJUSTMENT]: t('Float adjustment', {
      _context: 'Cash Movement Type',
    }),
    [CASH_MOVEMENT_TYPES.TILL_DISCREPANCY]: t('Till discrepancy', {
      _context: 'Cash Movement Type',
    }),
  }
}

export const useCashMovementsTypes = createUseTranslationMap(
  buildTypesMap,
  (key: string) => typesMap[key]
)
